/* Copyright (c) 2023 Xperi. All Rights Reserved.  */

import { AnyAction } from 'redux';
import { SET_ACTIVE_COMPONENT } from './interactivelayer.types';

export const setActiveInteractiveComponentAction = (activeComponent: string): AnyAction => ({
    type: SET_ACTIVE_COMPONENT,
    payload: {
        activeComponent,
    },
});
